export default __webpack_public_path__ + "static/thebottomline14-7c2ddcaf01fd6d41b8bc5204d3e25290.jpg";